<template>
  <div class="ArticleEdit text-left" v-title :data-title="title">
    <input v-model="detail.title" type="text" placeholder="请在这里输入标题...">
    <input v-model="detail.author" type="text" placeholder="请在这里输入作者...">
    <!-- <div>
      <button @click="printEditorHtml">print html</button>
      <button @click="getEditorText">print text</button>
    </div> -->
    <div style="border: 1px solid #ccc; margin-top: 10px">
      <!-- 工具栏 -->
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
      />
      <!-- 编辑器 -->
      <Editor
        style="height: 400px; overflow-y: hidden"
        :defaultConfig="editorConfig"
        v-model="detail.content"
        @onChange="onChange"
        @onCreated="onCreated"
      />
    </div>
    <div class="line mt7"></div>
    <div class="font-bold pt5 pb5">封面与摘要</div>
    <div class="row align-items-center">
      <div class="">
        <van-uploader v-model="coverPreview" :after-read="uploadCover" :max-count="1"/>
      </div>
      <div class="flex-1">
        <textarea v-model="detail.abstracts" placeholder="请在这里输入摘要..."></textarea>
      </div>
    </div>
    <div class="row justify-content-around mt10 pl7 pr7">
      <van-button @click="back" type="info" class="btn-common plain" plain>返回</van-button>
      <van-button @click="preview" type="info" class="btn-common">预览</van-button>
      <van-button v-if="!detail.id || detail.status == 0" @click="save(false)" type="info" class="btn-common">仅保存</van-button>
      <van-button @click="publishArticle" type="info" class="btn-common">发布</van-button>
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import config from '@/config';
import {
  sendRequest, getArticleDetail, addArticle, updateArticle, upload, uploadFile, publishArticle,
} from '@/network/NetworkAccessor';
import storage from '@/uitls/cacheUtil';

const uploadArticleFile = async (file) => {
  const params = new FormData();
  params.append('file', file);
  return upload(uploadFile, params).then((url = '') => `${config.FILE_DOMAIN}${url}`).catch((e) => {
    console.log(e);
  });
};
export default {
  name: 'MyEditor',
  components: { Editor, Toolbar },
  data() {
    return {
      title: '文章新增/编辑',
      editor: null,
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        // excludeKeys: [ /* 隐藏哪些菜单 */ ],
      },
      editorConfig: {
        placeholder: '请在这里输入正文...',
        // autoFocus: false,

        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            // 单个文件的最大体积限制，默认为 2M
            maxFileSize: 1 * 1024 * 1024, // 1M
            allowedFileTypes: [],
            // 自定义上传
            async customUpload(file, insertFn) {
              // file 即选中的文件
              // 自己实现上传，并得到图片 url alt href
              // 最后插入图片
              const url = await uploadArticleFile(file);
              if (!url) {
                this.$dialog.alert({
                  message: '图片上传失败',
                });
                return;
              }
              insertFn(url, '图片', '');
            },
          },
        },
      },

      loading: false,
      detail: {
        id: '',
        title: '',
        author: '',
        content: '',
        cover: '',
        abstracts: '',
        type: '',
      },
    };
  },
  computed: {
    coverPreview: {
      get() {
        return this.detail.cover ? [{
          url: this.detail.cover,
        }] : [];
      },
      set(list) {
        // console.log(list);
        if (!list || !list.length) {
          this.$set(this.detail, 'cover', '');
          this.$set(this.detail, 'cover', '');
        }
      },
    },
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    onChange(editor) {
      // console.log('onChange', editor.getHtml()); // onChange 时获取编辑器最新内容
    },
    // getEditorText() {
    //   const { editor } = this;
    //   if (editor == null) return;

    //   console.log(editor.getText()); // 执行 editor API
    // },
    // printEditorHtml() {
    //   const { editor } = this;
    //   if (editor == null) return;

    //   console.log(editor.getHtml()); // 执行 editor API
    // },

    getArticleDetail() {
      const storageInfo = storage.local.get('article_info');
      if (storageInfo && `${storageInfo.id || ''}` === `${this.detail.id || ''}`) {
        this.detail = {
          ...this.detail,
          ...storageInfo,
        };
        return;
      }
      if (!this.detail.id) {
        return;
      }
      sendRequest({
        ...getArticleDetail,
        url: `${getArticleDetail.url}/${this.detail.id}`,
      }).then((res) => {
        this.detail = res || {};
        // console.log(this.detail, res);
        // const {title = '', author = '', content = '', cover = '', abstracts = '', id = '', type} = res.data || {};
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    uploadCover(file) {
      uploadArticleFile(file.file).then((url) => {
        // console.log('uploadCover url~~~~~', url);
        if (!url) {
          this.$dialog.alert({
            message: '图片上传失败',
          });
          return;
        }
        this.$set(this.detail, 'cover', url);
      });
    },
    save(publish) {
      const { content = '' } = this.detail;
      if (!content || content === '<p><br></p>') {
        this.$dialog.alert({
          message: '请输入正文',
        });
        return Promise.reject(new Error('请输入正文'));
      }
      if (this.detail.id) {
        return this.updateArticle(publish);
      }
      return this.addArticle(publish);
    },
    preview() {
      storage.local.set('article_info', this.detail);
      this.$router.push('/article/detail');
    },
    addArticle(publish) {
      return sendRequest(addArticle, {
        ...this.detail,
      }).then((res) => {
        this.detail.id = res;
        this.$set(this.detail, 'id', res);
        if (!publish) {
          this.$dialog.alert({
            message: '新增成功',
          });
          this.$router.back();
        }
      });
    },
    updateArticle(publish) {
      return sendRequest({
        ...updateArticle,
        url: `${updateArticle.url}/${this.detail.id || ''}`,
      }, this.detail).then((res) => {
        if (!publish) {
          this.$dialog.alert({
            message: '修改成功',
          });
          this.$router.back();
        }
      });
    },
    publishArticle() {
      this.save(true).then(() => sendRequest({
        ...publishArticle,
        url: `${publishArticle.url}/${this.detail.id || ''}`,
      }, this.detail).then((res) => {
        this.$dialog.alert({
          message: '发布成功',
        });
        this.$router.back();
      })).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    back() {
      this.$router.back();
      // this.$router.push('/home');
    },
  },
  created() {
    // this.getUploadImageConfig();
    const { id = '' } = this.$route.params;
    const { type = '', typeName = '' } = this.$route.query;
    this.title = `${id ? '编辑' : '新增'}${typeName ? decodeURIComponent(typeName) : '文章'}`;
    this.detail = {
      ...this.detail,
      id,
      type,
    };
    this.getArticleDetail();
  },
  mounted() {
  },
  beforeDestroy() {
    const { editor } = this;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁 editor ，重要！！！
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
  .ArticleEdit {
    min-height: 100vh;
    background-color: #ffffff;
    font-size: 14px;
    padding: 10px;
  }
  input, select {
    min-height: 28px;
    width: 100%;
    font-size: 14px;
    border: 0;
    background-color: #ffffff;
  }
  textarea {
    border: 1px solid #f5f5f5;
    /* background-color: #f5f5f5; */
    width: 100%;
    min-height: 80px;
    padding: 8px;
  }
  .btn-common {
    width: 80px!important;
  }
</style>
